import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { spotFinder } from './endpoints';
import axiosBaseQuerySpotfinder from './axiosBaseQuerySpotfinder';

export const paymentApi = createApi({
    reducerPath: 'paymentApi',
    baseQuery: axiosBaseQuerySpotfinder({ baseUrl: process.env.REACT_APP_SPOT_FINDER_BASE_URL }),
    tagTypes: ['payment'],
    endpoints: (builder) => ({
        savePaymentMethod: builder.mutation({
            query(body) {
                return {
                    url: spotFinder.PaymentMethodController.savePaymentMethod,
                    method: 'POST',
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                };
            },
        }),
        updatePaymentMethod: builder.mutation({
            query(body) {
                return {
                    url: spotFinder.PaymentMethodController.updatePaymentMethod,
                    method: 'PUT',
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                };
            },
        }),
        getAllPaymentMethod: builder.mutation({
            query(body) {
                return {
                    url: spotFinder.PaymentMethodController.getAllPaymentMethod,
                    method: 'GET',
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                };
            },
        }),
        deletePaymentMethod: builder.mutation({
            query(body) {
                return {
                    url: `${spotFinder.PaymentMethodController.deletePaymentMethod}${body.id}`,
                    method: 'DELETE',
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                };
            },
        }),
        uploadPaymentMethodImage: builder.mutation({
            query(body) {
                return {
                    url: `${spotFinder.PaymentMethodController.uploadPaymentMethodImage}`,
                    method: 'POST',
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                };
            },
        }),
    }),
});

export const {
    useDeletePaymentMethodMutation,
    useSavePaymentMethodMutation,
    useUpdatePaymentMethodMutation,
    useGetAllPaymentMethodMutation,
    useUploadPaymentMethodImageMutation,
} = paymentApi;
